// Arabisch (ar), ridesApp: zelfde vorm als ridesApp.nl.ts. Werkwoord eerst (Arabische volgorde):
// "{role} {name} هذه المرة" met role = يوصل (brengen) of يُرجع (halen).
export const appRidesAr = {
    unknown: 'غير معروف بعد',
    notNeeded: 'لا حاجة',
    perDay: 'يختلف حسب اليوم',
    perDayHint: 'مثلًا: الاثنين {a} والخميس {b}.',
    perDayHintOne: 'مثلًا: شخص يوم الاثنين وشخص آخر يوم الخميس.',
    sameEveryDay: 'نفس الشخص كل مرة',
    day: 'اليوم',
    roleOnDay: '{role} يوم {day}',
    change: 'تغيير',
    close: 'تم',
    droppedDays: {
        zero: 'من يقود يوم {days} سيُلغى: هذا اليوم لم يعد ضمن التكرار.',
        one: 'من يقود يوم {days} سيُلغى: هذا اليوم لم يعد ضمن التكرار.',
        two: 'من يقود أيام {days} سيُلغى: هذه الأيام لم تعد ضمن التكرار.',
        few: 'من يقود أيام {days} سيُلغى: هذه الأيام لم تعد ضمن التكرار.',
        many: 'من يقود أيام {days} سيُلغى: هذه الأيام لم تعد ضمن التكرار.',
        other: 'من يقود أيام {days} سيُلغى: هذه الأيام لم تعد ضمن التكرار.',
    },
    cantDrive: 'لا تستطيع؟ شخص آخر',
    iCant: 'لا أستطيع، اتركه مفتوحًا',
    someoneElse: 'شخص آخر يقود',
    whoInstead: 'من {role} يوم {date}؟',
    whoInsteadHint: 'هذه المرة فقط. تبقى المرات الأخرى كما هي.',
    onlyThisTime: 'هذه المرة فقط',
    usually: 'عادةً {name}',
    usuallyNobody: 'عادةً لا أحد بعد',
    everyWeekday: 'كل {day}',
    backToUsual: 'العودة إلى المعتاد',
    takenOver: '{role} {name} هذه المرة',
    nobodyNow: '{role}: هذه المرة «من يقود؟». يراه الآخرون.',
    backDone: '{role} كالمعتاد من جديد',
    verbDropoff: 'يوصل',
    verbPickup: 'يُرجع',
};
//# sourceMappingURL=ridesApp.ar.js.map